import { render } from "./AskQuestionModal.vue?vue&type=template&id=36915028"
import script from "./AskQuestionModal.vue?vue&type=script&lang=js"
export * from "./AskQuestionModal.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__